const formatHtml = (input) => {
  if (input) {
    let output = input.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
    return output;
  }
  return input;
};

export default formatHtml;
